var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWidgetSuccess = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4998 57.3334C45.7672 57.3334 57.3332 45.7674 57.3332 31.5001C57.3332 17.2327 45.7672 5.66675 31.4998 5.66675C17.2325 5.66675 5.6665 17.2327 5.6665 31.5001C5.6665 45.7674 17.2325 57.3334 31.4998 57.3334Z",
    stroke: "#035E11",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7732 25.2806C41.2835 25.7966 41.2835 26.6332 40.7732 27.1492L30.3188 37.7197C29.8085 38.2357 28.9811 38.2357 28.4708 37.7197L23.2436 32.4344C22.7333 31.9184 22.7333 31.0818 23.2436 30.5658C23.7539 30.0498 24.5813 30.0498 25.0917 30.5658L29.3948 34.9167L38.9251 25.2806C39.4354 24.7646 40.2628 24.7646 40.7732 25.2806Z",
    fill: "#035E11"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWidgetSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/widget-success.376b577a029f50f01b042f671db94482.svg";